import { Box, Container, Stack, Typography, alpha } from '@mui/material';
import { Article } from 'types/blog';
import { formatDate } from 'const/blog';
import BlogBreadcrumb from './BlogBreadcrumb';
import { findCategoryByLabel } from 'const/blog/categories';
import { inline } from './InlineText';

// ==============================|| 記事ページのヘッダー ||============================== //
//
// ファーストビューで「何の記事か」「いつの情報か」を伝える。
// 制度の解説記事は情報の新しさが信頼に直結するため、更新日を目立つ位置に出している。
//
// パンくずをここに置いているのは、記事から一覧・トップへ戻る導線を
// 画面上部に用意するため(構造化データのパンくずは pages/blogArticle.tsx 側で出している)。

const primaryColor = '#2aa1af';

const ArticleTop = ({ article }: { article: Article }) => (
    <Box
        component="header"
        sx={{
            // 上に BlogHeader(細い固定バー)が乗るぶん、余白は控えめにする
            pt: { xs: 4, md: 5 },
            pb: { xs: 5, md: 7 },
            background: `linear-gradient(180deg, ${alpha(primaryColor, 0.1)} 0%, ${alpha(primaryColor, 0.02)} 100%)`
        }}
    >
        <Container maxWidth="md">
            <Box sx={{ mb: 3 }}>
                <BlogBreadcrumb category={findCategoryByLabel(article.category)} current={article.title} />
            </Box>

            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2.5 }} flexWrap="wrap" useFlexGap>
                <Typography
                    component="span"
                    sx={{ px: 1.5, py: 0.5, borderRadius: 1, bgcolor: primaryColor, color: '#fff', fontSize: '0.72rem', fontWeight: 800 }}
                >
                    {article.category}
                </Typography>
                <Typography component="span" sx={{ color: '#6b7280', fontSize: '0.78rem', fontWeight: 600 }}>
                    公開日 <time dateTime={article.publishedAt}>{formatDate(article.publishedAt)}</time>
                </Typography>
                {article.updatedAt !== article.publishedAt && (
                    <Typography component="span" sx={{ color: '#6b7280', fontSize: '0.78rem', fontWeight: 600 }}>
                        最終更新 <time dateTime={article.updatedAt}>{formatDate(article.updatedAt)}</time>
                    </Typography>
                )}
            </Stack>

            <Typography
                variant="h1"
                sx={{
                    fontSize: { xs: '1.6rem', sm: '1.9rem', md: '2.3rem' },
                    fontWeight: 900,
                    lineHeight: 1.5,
                    color: '#0f3d43',
                    mb: { xs: 3, md: 4 }
                }}
            >
                {article.title}
            </Typography>

            {/* 導入文。ここで読者の悩みに触れ、この記事で何が分かるかまでを示す */}
            <Box>
                {article.lead.map((line, index) => (
                    <Typography
                        key={index}
                        component="p"
                        sx={{
                            color: '#374151',
                            fontSize: { xs: '0.95rem', md: '1rem' },
                            lineHeight: 2.05,
                            mb: index === article.lead.length - 1 ? 0 : 2
                        }}
                    >
                        {inline(line)}
                    </Typography>
                ))}
            </Box>
        </Container>
    </Box>
);

export default ArticleTop;
